import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getIsDiagnosticAssigned, getDiagnostic } from 'store/diagnostics/selectors';

import { getCourseAvailableSubscription } from './selectors';
import { BANNER_TYPES } from './typings';

interface Params {
    courseId: number | null;
}

export const useOverviewBannerType = ({ courseId }: Params) => {
    const { subject } = useParams<{ subject: string; classId: string }>();

    const diagnostic = useSelector((state) => getDiagnostic(state, { subject }));
    const isDiagnosticAssigned = useSelector((state) => getIsDiagnosticAssigned(state, { subject }));
    const availableSubscription = useSelector((store) => getCourseAvailableSubscription(store, { courseId }));

    if (diagnostic && !isDiagnosticAssigned) {
        return BANNER_TYPES.DIAGNOSTIC;
    }

    if (availableSubscription) {
        return BANNER_TYPES.SUBSCRIPTION;
    }

    return BANNER_TYPES.CREATE_LESSON;
};
